import React, { useState, useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import { withRouter } from "../../../providers/withRouter";
import { getProveedor, getUserPropertieList, getAaffListSuplier } from "../../../services";
import { getTrabajadores } from "../../../services/trabajador.service";
import { UsuarioContext } from "../../../providers/userContext";
import CircularProgress from "@mui/material/CircularProgress";
import ProveedorLegalia from "./diseños/legalia/proveedor";
import ProveedorOriginal from "./diseños/original/proveedor";
import Comentarios from "../../../components/proveedores/comentarios";
import useListNavigation from "../../../hooks/useListNavigation";

// Trae TODOS los nif de proveedores en el orden del listado (mismos filtros/orden).
const fetchAllProveedorNifs = (ctx) =>
  getAaffListSuplier({
    filtros: ctx.filtros || {},
    params: { page: 1, limit: 9999, order: ctx.order, orderBy: ctx.orderBy },
  }).then((res) => (res?.data || []).map((r) => r.nif).filter(Boolean));

const Proveedor = (props) => {
  const user = useContext(UsuarioContext);
  const [proveedor, setProveedor] = useState({});
  const [fincas, setFincas] = useState([]);
  const [trabajadores, setTrabajadores] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  // Scroll al hash (#trabajadores) cuando se cargan los datos
  useEffect(() => {
    if (!isLoading && location.hash) {
      setTimeout(() => {
        const el = document.getElementById(location.hash.replace('#', ''));
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 300);
    }
  }, [isLoading, location.hash]);

  useEffect(() => {
    setIsLoading(true);
    getProveedor(props.params.nif)
      .then((res) => {
        setProveedor(res);
        getUserPropertieList(props.params.nif)
          .then((resP) => {
            setFincas(resP.properties);
          });
        getTrabajadores(props.params.nif)
          .then((data) => {
            if (data && Array.isArray(data)) setTrabajadores(data);
          });
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [props.params.nif]);

  const { prev, next } = useListNavigation('proveedores', props.params.nif, fetchAllProveedorNifs);

  if (isLoading) {
    return <CircularProgress style={{ color: '#92004D', position: 'absolute', top: '50%', left: '50%' }} />;
  }

  return user.tieneLegalia ? (
    <ProveedorLegalia proveedor={proveedor} fincas={fincas} trabajadores={trabajadores} user={user} prevNif={prev} nextNif={next} />
  ) : (
    <ProveedorOriginal proveedor={proveedor} fincas={fincas} trabajadores={trabajadores} user={user} />
  );
};

export default withRouter(Proveedor);
